export interface GradeResult {
  grade: string
  label: string
  stars: number
  colour: string
}

export function computeGrade(spi: number): GradeResult {
  if (spi >= 0.95) return { grade: 'A+', label: 'Outstanding',  stars: 5, colour: '#2dd4bf' }
  if (spi >= 0.85) return { grade: 'A',  label: 'Excellent',    stars: 5, colour: '#10b981' }
  if (spi >= 0.75) return { grade: 'B+', label: 'Good',         stars: 4, colour: '#34d399' }
  if (spi >= 0.65) return { grade: 'B',  label: 'Satisfactory', stars: 3, colour: '#f59e0b' }
  if (spi >= 0.50) return { grade: 'C',  label: 'Marginal',     stars: 2, colour: '#fb923c' }
  return                  { grade: 'D',  label: 'Poor',         stars: 1, colour: '#f43f5e' }
}

export function formatMinutes(min: number): string {
  if (min >= 60) return `${(min / 60).toFixed(1)} h`
  return `${min.toFixed(1)} min`
}
